var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragHandleCurrentColor300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#090909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.89-178.62q-25.24 0-43.25-18.12-18.02-18.13-18.02-43.37t18.12-43.25q18.13-18.02 43.37-18.02t43.25 18.12q18.02 18.13 18.02 43.37t-18.12 43.25q-18.13 18.02-43.37 18.02Zm240 0q-25.24 0-43.25-18.12-18.02-18.13-18.02-43.37t18.12-43.25q18.13-18.02 43.37-18.02t43.25 18.12q18.02 18.13 18.02 43.37t-18.12 43.25q-18.13 18.02-43.37 18.02Zm-240-240q-25.24 0-43.25-18.12-18.02-18.13-18.02-43.37t18.12-43.25q18.13-18.02 43.37-18.02t43.25 18.12q18.02 18.13 18.02 43.37t-18.12 43.25q-18.13 18.02-43.37 18.02Zm240 0q-25.24 0-43.25-18.12-18.02-18.13-18.02-43.37t18.12-43.25q18.13-18.02 43.37-18.02t43.25 18.12q18.02 18.13 18.02 43.37t-18.12 43.25q-18.13 18.02-43.37 18.02Zm-240-240q-25.24 0-43.25-18.12-18.02-18.13-18.02-43.37t18.12-43.25q18.13-18.02 43.37-18.02t43.25 18.12q18.02 18.13 18.02 43.37t-18.12 43.25q-18.13 18.02-43.37 18.02Zm240 0q-25.24 0-43.25-18.12-18.02-18.13-18.02-43.37t18.12-43.25q18.13-18.02 43.37-18.02t43.25 18.12q18.02 18.13 18.02 43.37t-18.12 43.25q-18.13 18.02-43.37 18.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandleCurrentColor300);
export default __webpack_public_path__ + "static/media/drag_handle_current_color_300.24dfaae25ceb861422914c26ced9b016.svg";
export { ForwardRef as ReactComponent };